import React from "react";
import { Routes, Route } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout.jsx";
import MarketingLayout from "../layouts/MarketingLayout.jsx";
import DashboardLayout from "../layouts/DashboardLayout.jsx";
import ProtectedRoute from "./ProtectedRoute.jsx";

import Login from "../pages/Login/Login.jsx";
import ResetPassword from "../pages/Login/ResetPassword.jsx";
import Dashboard from "../pages/Dashboard/Dashboard.jsx";
import MyFilings from "../pages/Dashboard/MyFilings.jsx";
import Businesses from "../pages/Dashboard/Businesses.jsx";
import BusinessForm from "../pages/Dashboard/BusinessForm.jsx";
import TaxPreparers from "../pages/Dashboard/TaxPreparers.jsx";
import TaxPreparerForm from "../pages/Dashboard/TaxPreparerForm.jsx";
import PaymentHistory from "../pages/Dashboard/PaymentHistory.jsx";
import Subscriptions from "../pages/Dashboard/Subscriptions.jsx";
import Settings from "../pages/Dashboard/Settings.jsx";
import ReferralCredit from "../pages/Dashboard/ReferralCredit.jsx";
import Wizard from "../pages/Wizard/Wizard.jsx";
import Confirmation from "../pages/Confirmation/Confirmation.jsx";
import Home from "../pages/Marketing/Home.jsx";
import HowItWorks from "../pages/Marketing/HowItWorks.jsx";
import Rates from "../pages/Marketing/Rates.jsx";
import TaxCalculator from "../pages/Marketing/TaxCalculator.jsx";
import DueDateCalculator from "../pages/Marketing/DueDateCalculator.jsx";
import RejectCodesHub from "../pages/Marketing/RejectCodesHub.jsx";
import RejectCodePage from "../pages/Marketing/RejectCodePage.jsx";
import EsIndex from "../pages/Marketing/EsIndex.jsx";
import Pricing from "../pages/Marketing/Pricing.jsx";
import FAQ from "../pages/Marketing/FAQ.jsx";
import About from "../pages/Marketing/About.jsx";
import Contact from "../pages/Marketing/Contact.jsx";
import Terms from "../pages/Marketing/Terms.jsx";
import Privacy from "../pages/Marketing/Privacy.jsx";
import BlogIndex from "../pages/Marketing/BlogIndex.jsx";
import BlogPost from "../pages/Marketing/BlogPost.jsx";
import NotFound from "../pages/Marketing/NotFound.jsx";

const AppRoutes = () => (
  <Routes>
    <Route element={<MarketingLayout />}>
      <Route path="/" element={<Home />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/rates" element={<Rates />} />
      <Route path="/form-2290-tax-calculator" element={<TaxCalculator />} />
      <Route path="/form-2290-due-date-calculator" element={<DueDateCalculator />} />
      <Route path="/form-2290-reject-codes" element={<RejectCodesHub />} />
      <Route path="/form-2290-reject-codes/:codeSlug" element={<RejectCodePage />} />
      <Route path="/es" element={<EsIndex />} />
      <Route path="/es/:slug" element={<BlogPost lang="es" />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
    </Route>

    <Route element={<AuthLayout />}>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Route>

    <Route element={<DashboardLayout />}>
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/filings" element={<MyFilings />} />
        <Route path="/dashboard/businesses" element={<Businesses />} />
        <Route path="/dashboard/businesses/form" element={<BusinessForm />} />
        <Route path="/dashboard/preparers" element={<TaxPreparers />} />
        <Route path="/dashboard/preparers/form" element={<TaxPreparerForm />} />
        <Route path="/dashboard/payments" element={<PaymentHistory />} />
        <Route path="/dashboard/subscriptions" element={<Subscriptions />} />
        <Route path="/dashboard/referrals" element={<ReferralCredit />} />
        <Route path="/dashboard/settings" element={<Settings />} />
      </Route>

      {/* Wizard/Confirmation stay unprotected: marketing CTAs (e.g. the
          landing page's GradientButton) send anonymous visitors straight
          into the wizard, and it already handles the logged-out path on
          its own (AppContext's SEED/backend calls no-op without a token). */}
      <Route path="/wizard/review/:returnId" element={<Wizard />} />
      <Route path="/wizard/:step" element={<Wizard />} />
      <Route path="/confirm" element={<Confirmation />} />
    </Route>

    {/* A real 404 page, NOT a redirect to "/". The previous catch-all
        `<Navigate to="/" />` served the homepage with HTTP 200 for every bad
        URL, which Google indexes as a soft 404 - duplicate homepages scattered
        across junk URLs. react-snap prerenders /404 to build/404.html so nginx
        can return it with a genuine 404 status. */}
    <Route element={<MarketingLayout />}>
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default AppRoutes;
